import { render, staticRenderFns } from "./theme-switch.vue?vue&type=template&id=4ef69bf4"
import script from "./theme-switch.vue?vue&type=script&lang=js"
export * from "./theme-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports